import React, { useRef, useImperativeHandle, forwardRef, useState, useEffect } from "react";
import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";
import { useNavigate, useParams } from 'react-router-dom';
// import { CommanTitle } from "../../Partner/Comman";
import { useReactToPrint } from 'react-to-print';
import numberToWords from "number-to-words";
import axios from 'axios';
import TranslateButton from './translationButton';
import Sanscript from "@sanskrit-coders/sanscript";
import "./poster.css";
import { formatDate, formatIndianCurrency } from '../commonfunction/formatDate';
import {
  Box,
  Typography,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
  Modal,
  Fade,
  Backdrop,
  MenuItem,
  Menu,
} from "@mui/material";

const BASEURL = "/api"
const Poster = forwardRef((props, ref) => {
  const receiptRef = useRef();
  const param = useParams()
  //console.log(param);
  const componentsPDF = useRef();
  const [data, setData] = useState({});
  //console.log(data);
  const [selectedLang, setSelectedLang] = useState("English");
  const [open, setOpen] = useState(false); // Modal state
  const [products, setProducts] = useState([]);
  //console.log(products);
  const [value, setValue] = useState({});
  const [translateActive, setTranslateActive] = useState(false);
  //console.log(value);
  const [columns, setColumns] = useState({
    description: true,
    articles: true,
    weight: true,
    rate: true,
    totalFreight: true,
    mt: true,

  });
  const [translated, setTranslated] = useState({
    vendor_name: "",
    address: "",
    supplier_name: "",
    ship_to_address1: "",
    ship_to_district: ""
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [language, setLanguage] = useState("");

  const navigate = useNavigate();
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = (lang) => {
    setAnchorEl(null);
    setLanguage(lang);
    handleTranslate(lang); // Pass language to the translate function
  };

  const handleTranslateClick = () => {
    setTranslateActive(true);
    // The translate UI will show up after script callback runs
  };

  const handleTranslate = (lang) => {
    setSelectedLang(lang);

    let script = "devanagari";
    if (lang === "Marathi" || lang === "Hindi") {
      script = "devanagari";
    } else if (lang === "English") {
      script = "hk";
    }

    setTranslated({
      vendor_name: Sanscript.t(data.vendor_name?.toLowerCase() || "", "hk", script),
      address: Sanscript.t(data.address?.toLowerCase() || "", "hk", script),
      supplier_name: Sanscript.t(data.supplier_name?.toLowerCase() || "", "hk", script),
      ship_to_address1: Sanscript.t(data.ship_to_address1?.toLowerCase() || "", "hk", script),
      ship_to_district: Sanscript.t(data.ship_to_district || "", "itrans", script),
    });
  };
  useEffect(() => {
    // Load Google Translate script only once
    const addScript = () => {
      const script = document.createElement('script');
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    // Create the callback for Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,hi,mr',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        'google_translate_element'
      );
    };

    // Load the script
    addScript();
  }, []);
  const params = value
  //console.log(params?.id);


  const fetchProducts = async () => {
    if (params?.id) {

      try {
        const response = await axios.get(`${BASEURL}/products/${params?.id}`);
        //console.log(response);
        const activeProducts = response?.data?.products?.filter(product => product.active === true);
        setProducts(activeProducts);
      } catch (error) {
        //////console.error("Error fetching products:", error);
      }
    }

  }
  useEffect(() => {
    fetchProducts();
  }, [params]);

  useEffect(() => {
    const getsingleusers = async () => {
      const get = axios.get(`${BASEURL}/getsingleusers/${param.id}`)
        .then((res) => {

          // ////console.log(res);
          setData(res.data.data);
        })
        .catch((err) => {
          ////console.log(err);
        })
    }
    getsingleusers();
  }, [])

  useEffect(() => {
    const savedUser = localStorage.getItem("link");
    //console.log(savedUser);

    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      //console.log(parsedUser);

      setValue(parsedUser);
    }
    const savedInfo = localStorage.getItem("info");
    if (savedInfo) {
      const parsedInfo = JSON.parse(savedInfo);
      setValue(parsedInfo);
    }
  }, []);


  const totalInWords = data.total
    ? numberToWords.toWords(data.total).replace(/\b\w/g, (c) => c.toUpperCase()) + " Rupees Only"
    : "Zero Rupees Only";



  const findrate = (value) => {
    return products && products?.length > 0 && products?.find(item => item.name === value)?.rate
  }



  const handleDownload = async () => {
    if (receiptRef.current) {
      try {
        // Generate a high-resolution image
        const dataUrl = await toPng(receiptRef.current, { cacheBust: true, pixelRatio: 2 });

        const pdf = new jsPDF("l", "mm", "a4"); // 'l' for landscape
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const img = new Image();
        img.src = dataUrl;

        img.onload = () => {
          const aspectRatio = img.height / img.width;
          let imgWidth = (pdfWidth / 2) - 10; // Half of the width minus margin for both copies
          let imgHeight = imgWidth * aspectRatio;

          if (imgHeight > pdfHeight - 20) {
            const scaleFactor = (pdfHeight - 20) / imgHeight;
            imgWidth *= scaleFactor;
            imgHeight = pdfHeight - 20;
          }

          // Left side (first copy)
          pdf.addImage(dataUrl, "PNG", 5, 10, imgWidth, imgHeight);

          // Draw a dashed line between the two copies
          pdf.setLineDash([3, 3]); // Dotted line
          pdf.line(pdfWidth / 2, 0, pdfWidth / 2, pdfHeight);

          // Right side (second copy)
          pdf.addImage(dataUrl, "PNG", (pdfWidth / 2) + 5, 10, imgWidth, imgHeight);

          pdf.save("Receipt.pdf");
        };
      } catch (error) {
        //console.error("Error generating PDF:", error);
      }
    } else {
      //console.error("receiptRef is not set");
    }
  };

  // Expose the handleDownload function to parent component
  useImperativeHandle(ref, () => ({
    downloadReceipt: handleDownload,
  }));

  return (
    <>
      <div style={{ marginTop: "20px"}}  >
        <div

          ref={componentRef}
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "800px",
            minHeight: "800px",
            overflow: "hidden !important",
            margin: "5px auto",
            fontFamily: "'Times New Roman', Times, serif",
            backgroundColor: "white",
            padding: "20px",
            border: "1px solid #606060",
            
          
          }}


        >

          <div style={{ textAlign: "center" }} className="notranslate">

            <div variant="h6" align="center" className="notranslate" fontWeight="bold" style={{
              marginTop: "0", marginBottom: "0",
              lineHeight: "1.1",
              whiteSpace: "nowrap",
              letterSpacing: "-1.5px",
              color: "#d84922",
              fontSize: "33px",
              fontWeight: "bold", color: "#AA2B1D", fontWeight: "bold"

            }}>
              {value.id?.toUpperCase()}
            </div>
            <p className="subtitle-clg" style={{
              marginTop: "2", marginBottom: "0", fontSize: "22px", color: "#0a476d", fontWeight: "bold",
              lineHeight: "1.0",
              whiteSpace: "nowrap",
              letterSpacing: "-1.1px",


            }}>
              Handling & Transportation Contractors


            </p>
            <div style={{ marginTop: "0", marginBottom: "0" }} className="notranslate">
              {value.address}
            </div>
            <div style={{ marginTop: "0", marginBottom: "0" }} className="notranslate">
              Received goods as per details below for carriage Subject to condition overleaf
            </div>
          </div>

          <div style={{ width: "100%", marginTop: "15px", border: "1px solid black", padding: "5px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
              <div>
                <div style={{ marginBottom: "3px" }} className="notranslate">
                  <strong style={{fontSize:"17px"}}>Receipt No:</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }}> {data?.receipt_number || "NA"} </span>
                </div>
                <div style={{ marginBottom: "3px" }} className="notranslate">
                  <strong style={{fontSize:"17px"}} >From:</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }}> {data.from || "NA"} </span>
                </div>
                <div style={{ marginBottom: "3px" }} className="notranslate">
                  <strong style={{fontSize:"17px"}}>Driver Name:</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }}>  {data?.transport_driver_name || "NA"} </span>
                </div>

                <div >
                  <strong className="notranslate" style={{fontSize:"17px"}}>Consignor :</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }} className="notranslate">  {data?.vendor_name || "NA"} </span>

                  {translateActive && (
                    <span style={{ fontWeight: "normal", fontSize: "13px" }} className="translate-this">
                      ({data?.vendor_name || "NA"})
                    </span>
                  )}
                </div>

                <div >
                  <strong className="notranslate" style={{fontSize:"17px"}}>Address :</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }} className="notranslate">{data?.address || "NA"} </span>
                  {translateActive && (
                    <span style={{ fontWeight: "normal", fontSize: "13px" }} className="translate-this">  ({data?.address || "NA"}) </span>
                  )}

                </div>

              </div>

              <div>
                <div style={{ marginBottom: "3px", fontSize: "17px" }} className="notranslate">
                  <strong style={{fontSize:"17px"}}>Date:</strong> {formatDate(data?.createdAt || "NA")}
                </div>
                <div className="notranslate">
                  <strong style={{fontSize:"17px"}}>Truck No:</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }}>{data?.transport_number || "NA"} </span>
                </div>
                <div>
                  <strong> </strong>
                </div>
                <div >
                  <strong className="notranslate" style={{fontSize:"17px"}}>Consignee :</strong>{" "}
                  <span style={{ fontWeight: "normal", fontSize: "17px" }} className="notranslate">
                    {data?.supplier_name || "NA"}
                  </span>
                  {translateActive && (
                    <span style={{ fontWeight: "normal", fontSize: "13px" }} className="translate-this">
                      ({data?.supplier_name || "NA"})
                    </span>
                  )}
                </div>

                <div >
                  <strong className="notranslate" style={{fontSize:"17px"}}>Place :</strong>
                  <span style={{ fontWeight: "normal", fontSize: "17px" }} className="notranslate" > {data?.ship_to_address1 || "NA"}  </span>
                  {translateActive && (
                    <span style={{ fontWeight: "normal", fontSize: "13px" }} className="translate-this">
                      ({data?.ship_to_address1 || "NA"})
                    </span>
                  )}
                </div>
                <div >
                  <strong className="notranslate" style={{fontSize:"17px"}}>District :</strong>
                  <span style={{ fontWeight: "normal", fontSize: "17px" }} className="notranslate">{data?.ship_to_district || "NA"} </span>
                  {translateActive && (
                    <span style={{ fontWeight: "normal", fontSize: "13px" }} className="translate-this">
                      ({data?.ship_to_district || "NA"})
                    </span>
                  )}

                </div>
                <div className="notranslate">
                  <strong style={{fontSize:"17px"}}>Mobile No :</strong> <span style={{ fontWeight: "normal", fontSize: "17px" }}>{data?.mobileNo || "NA"} </span>
                </div>
              </div>

            </div>
          </div>


          <div style={{ width: "100%" }} className="notranslate">
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", textAlign: "center", border: "1px solid black", fontSize: "14px", }}>
              <thead style={{ backgroundColor: "#F5F5F5" }}>
                <tr>
                  {columns.description && (
                    <th style={{ padding: "4px", border: "1px solid black", fontWeight: "bold", color: "black" }}>
                      Description
                    </th>
                  )}
                  {columns.articles && (
                    <th style={{ border: "1px solid black", fontWeight: "bold", color: "black" }}>
                      Bag / Weight (kg)

                    </th>
                  )}
                  {columns.weight && (
                    <th style={{ border: "1px solid black", fontWeight: "bold", color: "black" }}>
                      No. of Bags
                    </th>
                  )}
                  {columns.mt && (
                    <th style={{ border: "1px solid black", fontWeight: "bold", color: "black" }}>
                      Metric Ton (MT)
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {data?.productDetails?.map((product, index) => (
                  <tr key={index}>
                    {columns.description && (
                      <td style={{ padding: "4px", border: "1px solid black" }}>
                        {product.product_name || "NA"}
                      </td>
                    )}
                    {columns.articles && (
                      <td style={{ padding: "4px", border: "1px solid black" }}>
                        {findrate(product.product_name) || "NA"}
                      </td>
                    )}
                    {columns.weight && (
                      <td style={{ padding: "4px", border: "1px solid black" }}>
                        {product.weight || "NA"}
                      </td>
                    )}
                    {columns.mt && (

                      <td style={{ padding: "4px", border: "1px solid black" }}>
                        {product?.mt || "NA"}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "6px" }} className="notranslate">
            <div><strong>Advance Cash:</strong> ₹ {formatIndianCurrency(data.sc) || "NA"}</div>
            <div><strong>Diesel:</strong> ₹ {formatIndianCurrency(data.hamali) || "NA"} </div>
            <div>
              <strong>Total Freight Payable:</strong> ₹{" "} {data?.topayamt || "0.00"}
              {/* {data?.topayamt
                ? numberToWords.toWords(data.topayamt).replace(/\b\w/g, (c) => c.toUpperCase()) + " Rupees Only"
                : "Zero Rupees Only"} */}
            </div>

            <Divider
              sx={{
                mb: 1,
                mt: 1,
                borderColor: "#444", // Darker divider color
                borderWidth: "1.5px", // Slightly thicker divider
              }}
            />
          </div>




          <div className="notranslate"> <strong>Terms and Conditions </strong> </div>
          <div variant="body2" component="ul" align="left" style={{ listStylePosition: "inside", paddingLeft: 0 }} className="notranslate">
            <li>
              LR once acknowledged confirms that consignee has received the goods in good condition and has no further claims.
            </li>
            <li>
              Subject to {value?.district || "NA"} Jurisdiction only.
            </li>
          </div>
          <Divider
            sx={{
              mb: 1,
              mt: 1,
              borderColor: "#444",
              borderWidth: "1.5px",
            }}
          />
          <div style={{ marginTop: '150px', fontWeight: 'bold', textAlign: "center", fontSize: "17px", display: "flex", justifyContent: "space-between" }} className="notranslate">
            <div><strong>Driver Signature</strong> </div>
            <div><strong>Receiver Signature</strong> </div>
            <div><strong>For: {value.id}</strong></div>
          </div>
        </div>


        <div className='no-print' >
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 3 }} className="notranslate">
            {/* Left Side: Buttons */}
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                Back
              </Button>
              <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
                Select Print Options
              </Button>
              <Button variant="contained" color="primary" onClick={handlePrint}>
                Print
              </Button>

            </Box>

            <div onClick={handleTranslateClick}>
              <div id="google_translate_element"></div>
            </div>

          </Box>

        </div>
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 300 }}
        >
          <Fade in={open}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400, // Slightly wider for better spacing
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 1,
                borderRadius: 3, // Rounded corners
                border: "1px solid #ccc", // Subtle border for better visibility
              }}
            >
              <Typography
                variant="h6"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#333" }} // Bold and dark text
              >
                Select Options to Print
              </Typography>
              <Divider
                sx={{
                  mb: 3,
                  borderColor: "#444", // Darker divider color
                  borderWidth: "1.5px", // Slightly thicker divider
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 1, // Increased gap for better spacing
                }}
              >
                {Object.keys(columns)
                  .filter((key) => key !== "rate" && key !== "totalFreight") // Exclude "rate" and "totalFreight"
                  .map((key) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          checked={columns[key]}
                          onChange={() =>
                            setColumns((prev) => ({ ...prev, [key]: !prev[key] }))
                          }
                          sx={{
                            color: "#555", // Subtle checkbox color
                            "&.Mui-checked": { color: "#1976d2" }, // Primary color for checked state
                          }}
                        />
                      }
                      label={
                        key === "articles"
                          ? "Bag / Weight (kg)"
                          : key === "weight"
                            ? "No. of Bags"
                            : key.charAt(0).toUpperCase() + key.slice(1)
                      }

                      sx={{
                        fontSize: "14px", // Slightly smaller font for labels
                        color: "#333", // Darker text color
                      }}
                    />
                  ))}


              </Box>
              <Box sx={{ textAlign: "center", mt: 4 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(false)}
                  sx={{
                    px: 3, // Add padding for a larger button
                    py: 0.5,
                    fontWeight: "bold",
                  }}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>
      </div>


    </>
  );
});

export default Poster;



